import { defineComponent, ref } from 'vue';
import { trackCubeCustomEvent } from '../tracking/trackingLayer.js';
import type { EntsModal } from '../modal/modal.js';

const templateElement = document.getElementById('additional-price-info-template');
export default defineComponent({
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    displayPrice: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const pangvModal = ref<EntsModal | null>(null);

    const openLayer = async () => {
      const modal = pangvModal.value as EntsModal;
      modal.addEventListener('ents-modal:close', onLayerClose);
      modal.classList.remove('hidden');
      await import('../modal/modal.js');
      await modal.updateComplete;
      modal.show();
      trackModalEvent('open');
    };

    const onLayerClose = () => {
      trackModalEvent('close');
      (pangvModal.value as EntsModal).removeEventListener('ents-modal:close', onLayerClose);
    };

    const trackModalEvent = (action: string) => {
      trackCubeCustomEvent(`pangv_layer_${action}`, {
        event_category: 'pangv_layer',
        is_interaction_event: true,
        event_type: 'click',
      });
    };

    return {
      openLayer,
      pangvModal,
    };
  },
});
